(function () {
  'use strict';

  function initComparison(root) {
    if (!root || root.dataset.ccInitialized === 'true') return;

    var tracks = Array.prototype.slice.call(root.querySelectorAll('.cc-mobile__track'));
    if (tracks.length === 0) return;

    var slideCount = tracks[0].querySelectorAll('.cc-mobile__slide').length;
    if (slideCount === 0) return;

    root.dataset.ccInitialized = 'true';

    var dots = Array.prototype.slice.call(root.querySelectorAll('.cc-mobile__dot'));
    var nextButtons = Array.prototype.slice.call(root.querySelectorAll('.cc-mobile__next'));
    var activeIndex = 0;

    function update() {
      // Percentage-based transform stays correct across viewport/resize changes
      // without any recalculation, since each slide is always 100% of its track.
      var transform = 'translateX(-' + activeIndex * 100 + '%)';
      tracks.forEach(function (track) {
        track.style.transform = transform;
      });

      dots.forEach(function (dot, i) {
        var isActive = i === activeIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
    }

    function goTo(index) {
      activeIndex = ((index % slideCount) + slideCount) % slideCount;
      update();
    }

    function next() {
      goTo(activeIndex + 1);
    }

    nextButtons.forEach(function (button) {
      button.addEventListener('click', next);
    });

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        goTo(i);
      });
    });

    update();
  }

  function initAll(scope) {
    var target = scope || document;
    var roots = target.querySelectorAll('.competitive-comparison');
    Array.prototype.forEach.call(roots, initComparison);

    if (target.classList && target.classList.contains('competitive-comparison')) {
      initComparison(target);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
